module.exports = __webpack_public_path__ + "static/media/defaultProfile.89ca4727.png";